import axios from 'axios'
import {quillRedefine} from 'vue-quill-editor-upload'
import {pointMap} from './pointMap'

const instaceHolder = {}

let currentUser = {}
let vue
let robotInfo = {}
let eventBus = new Map()
let nowRadio = null
let playingRadio = false
let audioSetInterval = null
let duration = ''
let navFunction = () => {
}
let orderData = {}
let startId = 0

const getInstance = () => {
  if (!instaceHolder.instance) {
    instaceHolder.instance = new HttpService()
  }
  return instaceHolder.instance
}

export class HttpService {


  static initVue(data) {
    vue = data
  }

  constructor() {
    const token = localStorage.getItem('X-Auth-token') || ''
    const lang = localStorage.getItem('accept-language') || (((navigator.language || navigator.userLanguage).substr(0, 2)) == 'zh' ? 'zh-CN' : 'en-US');
    console.log('当前语言：'+lang)
    this.axios = axios.create({
      headers:
      // 兼容IE不取缓存, 在请求头中默认添加no-cache
        {
          Pragma: 'no-cache',
          'cache-control': 'no-cache',
          'X-Auth-token': token,
          'accept-language': lang,
        },
      baseURL: process.env.NODE_ENV === 'development' ? '/api' : '../'
    })

    this.axios.interceptors.response.use(
      async (response) => {
        if (response.data.status == 'USERNOPAY' || response.data.status == 'ROBOTNOPAY') {
          vue.$store.commit('setPayStatus', true);
          console.warn('功能未付费')
          return Promise.reject(response);
        }
        if (!response.data && response.data !== false && response.data !== 0) {
          let functionList = eventBus.get('loginOut')
          if (functionList) {
            functionList.forEach(res => {
              res()
            })
          }
          // 清空token
          localStorage.removeItem('X-Auth-token')
          // 当接口返回空时, 回到登录页面
          // location.replace('/login')
          vue.$router.push('/login')
          return Promise.reject('未登录返回空')
        }

        // 对响应数据做点什么
        if (response.data.error) {
          vue.$message.error(response.data.message)
          return Promise.reject(response.data.message)
        }
        return response.data
      },
      (error) => {
        // 对响应错误做点什么
        if (error.response.status === 401 || error.response.status === 403) {
          // 清空token
          console.log(this)
          // this.runEventByName('loginOut')
          let functionList = eventBus.get('loginOut')
          if (functionList) {
            functionList.forEach(res => {
              res()
            })
          }


          localStorage.removeItem('X-Auth-token')
          // 当接口返回空时, 回到登录页面
          // location.replace('/login')
          vue.$router.push('/login')
          return Promise.reject('未登录返回空')
        }
        vue.$message.error('服务器开小差了, 请稍后重试!')
        if (error.response) {
          // 请求已发出，但服务器响应的状态码不在 2xx 范围内切不等于401 403
          // console.error(error.response.data)
          console.error(error.response.status)
          // console.error(error.response.headers)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error', error.message)
        }
        console.error(error.config)
        return Promise.reject(error)
      }
    )
  }

  static runEventByName(name, data, type) {
    let functionList = eventBus.get(name)
    if (functionList) {
      functionList.forEach(res => {
        res(data, type)
      })
    }
  }


  static setEventByName(name, fn) {
    let functionList = eventBus.get(name)
    if (functionList) {
      functionList.push(fn)
    } else {
      eventBus.set(name, [fn])
    }
  }

  static clearEventByName(name) {
    eventBus.set(name, [])
  }


  static setInitEventByName(name, fn) {
    eventBus.set(name, [fn])
  }

  dealUrl(url) {
    let param = []
    if (url.indexOf('?') > -1) {
      param = url.slice(url.indexOf('?') + 1).split('&').map(res => {
        let d = {
          key: res.split('=')[0],
          value: encodeURIComponent(res.split('=')[1])
        }
        return d
      })
      url = url.slice(0, url.indexOf('?'))
    }

    if (param.length > 0) {
      url = url + '?'
      param.forEach(r => {
        url = url + r.key + '=' + r.value + '&'
      })
    }
    return url
  }

  static dealParam(param) {
    let paramStr = '?'
    for (let p in param) {
      paramStr += p + '=' + param[p] + '&'
    }
    paramStr = paramStr.substring(0, paramStr.length - 1)
    return paramStr
  }

  _postFile(url, file, fn) {
    url = this.dealUrl(url)
    let formdata = new FormData()
    formdata.append('file', file)
    let config = {}
    if (fn) {
      config = {
        onUploadProgress: progressEvent => {
          var complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0
          fn(complete)
        }
      }
    }
    return this.axios.post(url, formdata, config)
  }

  _putFile(url, file) {
    url = this.dealUrl(url)
    let formdata = new FormData()
    formdata.append('file', file)
    return this.axios.put(url, formdata)
  }

  _get(url, params = null) {
    url = this.dealUrl(url)
    return this.axios.get(url, params)
  }

  _post(url, body = null, isFormData = false) {
    url = this.dealUrl(url)
    let config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }
    if (isFormData) {
      let ret = ""
      for (let it in body) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(body[it]) + '&'
      }
      return this.axios.post(url, ret, config)
    } else {
      return this.axios.post(url, body)
    }
  }

  _put(url, body = null, isFormData = false) {
    url = this.dealUrl(url)
    if (isFormData) {
      return this.axios.put(url, body, config)
    } else {
      return this.axios.put(url, body)
    }
  }

  _delete(url, body = null) {
    url = this.dealUrl(url)
    return this.axios.delete(url, {data: body})
  }

  _setToken(token) {
    if (token) {
      // vue.resetSetItem('X-Auth-token', token);
      localStorage.setItem('X-Auth-token', token)
      this.axios.defaults.headers['X-Auth-token'] = token
    }
  }

  _clearToken() {
    localStorage.removeItem('X-Auth-token')
    this.axios.defaults.headers['X-Auth-token'] = ''
  }

  _setLanguage(lang) {
    if (lang) {
      vue.$i18n.locale = lang;
      localStorage.setItem('accept-language', lang)
      this.axios.defaults.headers['accept-language'] = lang
    }
  }

  static postFile(url, file, fn) {
    return getInstance()._postFile(url, file, fn)
  }

  static putFile(url, file) {
    return getInstance()._putFile(url, file)
  }

  static get(url, params = null) {
    return getInstance()._get(url, params)
  }

  static post(url, params = null, isFormData) {
    return getInstance()._post(url, params, isFormData)
  }

  static put(url, params = null, isFormData) {
    return getInstance()._put(url, params, isFormData)
  }

  static delete(url, params = null) {
    return getInstance()._delete(url, params)
  }

  static setToken(token) {
    getInstance()._setToken(token)
  }

  static clearToken() {
    getInstance()._clearToken()
  }

  static setLanguage(lang) {
    getInstance()._setLanguage(lang)
  }


  static getCurrentUser() {
    return currentUser
  }

  static setCurrentUser(cur) {
    currentUser = cur
  }

  static setRobotInfo(data) {
    robotInfo = data
  }

  static getRobotInfo() {
    return robotInfo
  }

  static getMaterialSrc(robotId, sid, type, isPublic = true) {
    const tenantId = this.getCurrentUser().tenantId
    if (isPublic) {
      if (/^http/.test(sid)) {
        return sid
      }
      return `${process.env.NODE_ENV === 'development' ? 'https://devbot.4paradigm.com' : location.origin}/v1/tenants/${tenantId}/robots/${robotId}/public_material/file/${type}/${sid}`

    } else {
      if (/^http/.test(sid)) {
        return sid
      }
      return `${process.env.NODE_ENV === 'development' ? 'https://devbot.4paradigm.com' : location.origin}/v1/tenants/${tenantId}/robots/${robotId}/material/file/${type}/${sid}`
    }
  }

  static dateFormat(time, isKefu = false, isHour = false) {
    var date = new Date(time)
    var year = date.getFullYear()
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    // 拼接
    if (isKefu) {
      return hours + ':' + minutes;
    } else if (isHour) {
      return year + '-' + month + '-' + day + ' ' + hours
    } else {
      return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + 'Z'
    }
  }

  static putUser(data) {
    const tenantId = this.getCurrentUser().tenantId
    const userId = this.getCurrentUser().userId
    return this.put(`/v1/tenants/${tenantId}/users/${userId}`, data)
  }

  static playRadio(audio) {
    if (nowRadio !== audio) {
      nowRadio && (nowRadio.pause())
      audio.play()
      nowRadio = audio
      playingRadio = true
      audioSetInterval && (clearInterval(audioSetInterval))
      audioSetInterval = setInterval(_ => {
        duration = (parseInt(audio.duration) - parseInt(audio.currentTime)) + '"'
        // console.log(duration);
        if (duration == (0 + '"')) {
          clearInterval(audioSetInterval)
          audioSetInterval = null
          playingRadio = false
          duration = parseInt(audio.duration) + '"'
        }
      }, 1000)
    } else {
      // audio.pause()
      audio.paused ? (audio.play()) : (audio.pause())
      if (audio.paused) {
        playingRadio = false;
      } else {
        playingRadio = true;
      }
      // playingRadio = false
      audioSetInterval && (clearInterval(audioSetInterval))
    }
    return playingRadio
  }

  //停止播放所有语音
  static pauseAudio() {
    nowRadio && (nowRadio.pause())
  }

  static getQuillRedefine() {
    return quillRedefine({
      uploadConfig: {
        action: `${this.baseURL}v1/tenants/${this.tenantId}/robots/${this.robotId}/material/image?status=HIDE`,  // 必填参数 图片上传地址
        // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
        // 你必须把返回的数据中所包含的图片地址 return 回去
        res: (respnse) => {
          return respnse.url || this.$httpService.getMaterialSrc(this.robotId, respnse.materialId, 'IMAGE', true)
        },
        methods: 'POST',  // 可选参数 图片上传方式  默认为post
        token: sessionStorage.token,  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        name: 'file',  // 可选参数 文件的参数名 默认为img
        size: 1024,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
        change: formData => {
          // console.log('formData', this.$refs.myQuillEditor.$el.querySelector('input.ql-image[type=file]'))
          let file = this.$refs.myQuillEditor.$el.querySelector('input.ql-image[type=file]').files[0]
          if (file.size > 1024 * 1024) {
            this.$message.warning('图片大小不能大于1M')
            return
          }
        },
        start: () => {

        },  // 可选参数 接收一个函数 开始上传数据时会触发
        end: () => {
        },  // 可选参数 接收一个函数 上传数据完成（成功或者失败）时会触发
        success: () => {
        },  // 可选参数 接收一个函数 上传数据成功时会触发
        error: () => {

        }  // 可选参数 接收一个函数 上传数据中断时会触发
      },
      placeholder: '请输入图文内容'
    })
  }

  static ws = null
  // 进行脏值检测的页面名称
  static checkRouterName = ['编辑问答', '编辑素材', '编辑任务', '添加自动应答','创建工单','工单详情'];

  static pageDerty() {
    vue.$pageDerty = true
    if (this.checkRouterName.indexOf(vue.$route.name) > -1 && vue.$route.query.type != 'MENU') {
      window.onbeforeunload = function (event) {
        return '您可能有数据没有保存';
      };
    }
  }

  static pageClear() {
    vue.$pageDerty = false
    window.onbeforeunload = null
  }

  static getPageDerty() {
    return vue.$pageDerty
  }

  // 面包屑导航
  /**
   *
   * @param data [{name:'',path:''}]
   */
  static setNav(data) {
    if (typeof navFunction == 'function') {
      navFunction(data)
    }
  }

  static setNavFn(fn) {
    navFunction = fn
  }

  static getOldTenantId(tenantId) {
    if (startId > 0) {
      return Promise.resolve(startId)
    } else {
      return this.get(`/v1/tenants/{tenantId}/order/startCheckVersionTenantId`)
    }
  }


  // 获取订单信息
  static getOrder(tenantId) {
    return this.get(`/v1/tenants/${tenantId}/order/getNowOrder`).then(res => {
      orderData = res
      return res
    })

  }


  static setpoint(msg, type = 'CLICK') {
    let typeEnum = ['CLICK','UPDATA_MSG','DELET_ROBOT','CREATE_ROBOT']
    if(typeEnum.indexOf(type)>-1&&pointMap.get(msg)) {
      return this.post(`/v1/activity/point`, {
        tenantId: currentUser.tenantId,
        userId: currentUser.userId,
        msg: pointMap.get(msg),
        type: type
      })
    }else {
      return Promise.reject('point is error:'+msg)
    }
  }


}

export const environment = {
  production: false,
  HOST: 'api',
  name: 'local',
  getWSHost: function () {
    return 'devbot.4paradigm.com'
  }
}



// WEBPACK FOOTER //
// ./services/httpService.js